export const apiCreate = (): string => '/commercial/proposals/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/proposals/' : `/commercial/proposals/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/proposals/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/proposals/delete/${id}`
